module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/4@2x_80bd19887876927f2b467adcd01ec309.png";